import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { blue, orange } from "@mui/material/colors";
import type { FC } from "react";
import { formatDate } from "../../data/dataUtils";
import type { SavedOrderProductWithNames } from "../orderTypes";
import "./OrderCardProducts.scss";

interface Props {
  readonly products: SavedOrderProductWithNames[];
  readonly showHistorical: boolean;
}

const OrderCardProducts: FC<Props> = ({ products, showHistorical }) => (
  <Table className="order-card-products">
    <TableBody>
      {products
        .filter((p) => showHistorical || !p.cancelled)
        .map((p, idx) => (
          <TableRow
            className={`row ${p.cancelled ? "cancelled" : ""}`}
            key={`${p.id}:${idx}`}
            style={{ height: "auto" }}
          >
            <TableCell style={{ color: blue["600"] }}>{p.providerName}</TableCell>
            <TableCell>{p.bookingNumber}</TableCell>
            <TableCell style={{ color: orange["900"] }}>{p.name}</TableCell>
            <TableCell>{formatDate(p.date)}</TableCell>
          </TableRow>
        ))}
    </TableBody>
  </Table>
);

export default OrderCardProducts;
